/**
 * Emplacements où le message promo agence peut s'afficher.
 *
 * Chaque emplacement a sa propre configuration en base (colonne `slot` de
 * `agency_home_promo_message`) : la page de garde affiche le message en pleine
 * largeur, les affaires en cours dans une carte étroite. Un même HTML ne peut
 * pas rendre correctement dans les deux, d'où deux messages distincts.
 */
export const PROMO_MESSAGE_SLOTS = ['home', 'reprise'] as const;

export type PromoMessageSlot = (typeof PROMO_MESSAGE_SLOTS)[number];

export interface PromoMessageSlotDefinition {
  slot: PromoMessageSlot;
  label: string;
  description: string;
  /** Largeur utile réelle de l'emplacement, utilisée pour l'aperçu à l'échelle. */
  previewWidth: number;
}

export const PROMO_MESSAGE_SLOT_DEFINITIONS: PromoMessageSlotDefinition[] = [
  {
    slot: 'home',
    label: 'Page de garde',
    description: "Bandeau affiché en pleine largeur sous les services, sur l'accueil agence.",
    previewWidth: 1180,
  },
  {
    slot: 'reprise',
    label: 'Affaires en cours',
    description: 'Encart affiché dans la carte de gauche, au-dessus des boutons carte grise et reprise.',
    previewWidth: 500,
  },
];

export interface PromoFranchiseMessage {
  franchise_id: string;
  message: string;
}

export interface PromoMessageConfig {
  slot?: PromoMessageSlot;
  is_active: boolean;
  default_message: string;
  franchise_messages: PromoFranchiseMessage[];
}
